import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '&&': {
      overflow: 'hidden',
      minHeight: '100svh',
      flexDirection: 'row',
      position: 'relative',
      flexWrap: 'nowrap',
    },
  },

  innerContentWrapper: {
    '&&': {
      [theme.breakpoints.down('laptop')]: {
        paddingLeft: SPACES.xxl,
        paddingRight: SPACES.xxl,
      },
      [theme.breakpoints.down('laptop_l')]: {
        paddingLeft: SPACES.xxl,
        paddingRight: SPACES.xxl,
      },
      [theme.breakpoints.up('laptop_l')]: {
        paddingLeft: SPACES.xxl,
        paddingRight: '70px',
      },
    },
  },

  navbarWrapper: {
    '&&': {
      [theme.breakpoints.down('laptop')]: {
        display: 'none',
      },
      [theme.breakpoints.up('laptop')]: {
        position: 'relative',
        zIndex: 1000,
      },
    },
  },
  contentWrapper: {
    '&&': {
      width: '100%',
      minHeight: 'calc(100% - 80px)',

      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'space-between',

      // gap: SPACES.xxxxl,
      gap: '2px',

      [theme.breakpoints.down('tablet')]: {
        marginBottom: '80px',
      },
      [theme.breakpoints.up('tablet')]: {
        marginBottom: '20px',
      },
    },
  },
}))

export default useStyles
